<!-- Builder Start -->
<div id="{{position}}" class="position-relative">
  <div [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
    class="app-header-background cta-app-header-background grid-global-container"
    [ngStyle]="{'background-color':backgroundColor}" [ngClass]="activatePadding?'header-padding-top':''">
    <!-- Photo Grid -->
    <div [attr.data-aos]="textAnimation ? textAnimation : null" class="app-header-headline">
      <h1 [ngStyle]="{ 'color': titleColor?titleColor:'#000000','font-weight':fontWeight }" class="mat-h1"
        [ngClass]="[titleSize]" [innerHtml]="title | safeHtml"></h1>
    </div>
    <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" class="container-gird-list"
      [ngStyle]="{'max-width':maxWidth+'px'}">
      <div class="row-gird-list">
        <div class="column-gird-list"
          [ngStyle]="{'-ms-flex': (100/imagesPerLine)+'%', 'flex':(100/imagesPerLine)+'%', 'max-width':(100/imagesPerLine)+'%','padding':'0 4px'}"
          *ngFor="let line of adaptedImageSlider;let i = index">
          <img (error)="updateUrl($event)" (click)="openImage(img)" *ngFor="let img of line" [src]="img"
            style="width:100%" [alt]="title+'-'+siteName+'-'+j">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Builder End -->

<!-- <img *ngIf="sliderIndex>-1 && !isString(images) && images[sliderIndex]"  style="display: none;" [src]="images[sliderIndex]" class="hero-image" [alt]="title" (error)="updateUrl($event)"> -->